import {
  ChangePasswordPayload,
  SetPasswordPayload,
} from "@/types/ApiResponses/Auth";
import { NewUser } from "@/types/ApiResponses/User";
import { api } from "..";
import { ApiResponse, QueryProps } from "@/types/Api";
import { Account } from "@/types/ApiResponses/Account";

export const changePassword = async (
  payload: ChangePasswordPayload
): Promise<NewUser> => {
  const res = await api.client.post(
    "/auth-new/accounts/change-password",
    payload
  );
  return res.data;
};

export const setPassword = async (
  payload: SetPasswordPayload
): Promise<ApiResponse> => {
  const res = await api.client.post("/auth-new/accounts/set-password", payload);
  return res.data;
};

export const getAccounts = async (props: QueryProps): Promise<Account[]> => {
  const res = await api.client.get("/auth-new/accounts", {
    signal: props.signal,
  });
  return res.data;
};
